import { render, staticRenderFns } from "./payment-step.vue?vue&type=template&id=17808926&"
import script from "./payment-step.vue?vue&type=script&lang=js&"
export * from "./payment-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports